import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const DatePickerModal = ({ isOpen, onClose }) => {
  const [currentDate, setCurrentDate] = useState(new Date(2022, 1, 24)); // February 2022
  if (!isOpen) return null;

 
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const currentMonth = monthNames[currentDate.getMonth()];
  const currentYear = currentDate.getFullYear();

  const daysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();
  const firstDayOfMonth = (month, year) => new Date(year, month, 1).getDay();

  const renderCalendar = () => {
    const totalDays = daysInMonth(currentDate.getMonth(), currentYear);
    const startingDay = firstDayOfMonth(currentDate.getMonth(), currentYear);
    const days = [];

    const prevMonthDays = daysInMonth(currentDate.getMonth() - 1, currentYear);
    for (let i = 0; i < startingDay; i++) {
      days.push(<div key={`prev-${i}`} className="text-center py-2 text-gray-400">{prevMonthDays - startingDay + i + 1}</div>);
    }

    for (let day = 1; day <= totalDays; day++) {
      const isSelected = day === 24 && currentDate.getMonth() === 1 && currentDate.getFullYear() === 2022;
      const isRange = [4, 5, 6, 7, 8, 9, 10].includes(day) && currentDate.getMonth() === 1 && currentDate.getFullYear() === 2022;
      days.push(
        <div key={day} className={`text-center py-2 rounded-lg cursor-pointer ${isSelected ? 'bg-red-600 text-white' : isRange ? 'bg-red-100 text-red-700' : 'hover:bg-gray-100'}`}>
          {day}
        </div>
      );
    }
    
    const remainingCells = 42 - days.length;
    for (let i = 1; i <= remainingCells; i++) {
        days.push(<div key={`next-${i}`} className="text-center py-2 text-gray-400">{i}</div>);
    }

    return days;
  };

  const prevMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  };

  const nextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  };

  const quickSelections = ["Last 7 days", "Last 14 days", "Last 30 days", "Last 3 months", "Last 12 months", "Select Time", "Custom"];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50" dir="ltr">
      <div className="bg-white rounded-2xl shadow-lg flex" onClick={(e) => e.stopPropagation()}>
        <div className="w-[200px] p-4 border-r border-gray-200">
          <ul className="space-y-2">
            {quickSelections.map(item => (
              <li key={item} className={`p-2 rounded-lg text-sm font-medium cursor-pointer ${item === 'Last 7 days' ? 'bg-gray-100 text-gray-800' : 'text-gray-700 hover:bg-gray-100'}`}>
                {item}
              </li>
            ))}
          </ul>
        </div>
        <div className="p-6 w-[500px]">
          <div className="flex justify-between items-center mb-4">
            <button onClick={prevMonth} className="p-2 rounded-full hover:bg-gray-100">
              <ChevronLeft size={20} />
            </button>
            <div className="font-semibold text-lg">{currentMonth} {currentYear}</div>
            <button onClick={nextMonth} className="p-2 rounded-full hover:bg-gray-100">
              <ChevronRight size={20} />
            </button>
          </div>
          <div className="grid grid-cols-7 gap-1 text-sm">
            {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map(day => (
              <div key={day} className="text-center font-medium text-gray-500 py-2">{day}</div>
            ))}
            {renderCalendar()}
          </div>
          <div className="flex justify-end gap-4 mt-6" dir="rtl">
            <button onClick={onClose} className="px-6 py-2.5 border border-gray-300 rounded-lg text-gray-800 font-semibold hover:bg-gray-100 transition-colors">
              الغاء
            </button>
            <button onClick={onClose} className="px-6 py-2.5 bg-[var(--Primary-Primary)] text-white rounded-lg font-semibold shadow-sm hover:bg-red-700 transition-colors">
              تأكيد
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatePickerModal;
